<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-10-27 11:01:25
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2023-12-09 14:43:37
 * @FilePath: \minipro-manger\src\views\Home\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <el-container style="wdith:100vw;height:100vh">
      <el-aside :width="asideWidth" style="background-color:#232A35;">
        <div class="logoBox">
          <div class="logoImg">
            <img
              src="https://moodsci.com/fonts/logo.61f14fcb.png"
              alt
              style="width:100%;height:100%"
            />
          </div>
          <div class="logoText" v-show="!isCollapse">崇州农业气象后台</div>
        </div>
        <el-menu
          default-active="UserFeedback"
          class="el-menu-vertical-demo"
          background-color="#232A35"
          text-color="white"
          :router="true"
          :unique-opened="true"
          :collapse="isCollapse"
        >
          <!-- <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-user-solid"></i>
              <span>用户管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="1-1">用户档案</el-menu-item>
            </el-menu-item-group>
          </el-submenu>-->
          <!-- <el-menu-item index="menuSet">
            <i class="el-icon-menu"></i>
            <span slot="title">菜单管理</span>
          </el-menu-item>-->
          <el-submenu index="2">
            <template slot="title">
              <i class="el-icon-s-cooperation"></i>
              <span>内容管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="weatherAlert">气象科普</el-menu-item>
              <el-menu-item index="RiskSurvey">风险普查</el-menu-item>
              <el-menu-item index="RuralTou">气象灾害</el-menu-item>
              <el-menu-item index="IntelligentBase">种植基地</el-menu-item>
              <el-menu-item index="Send">成果推送</el-menu-item>
              <el-menu-item index="Guidance">农技指导</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">
              <i class="el-icon-phone"></i>
              <span>互动管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="UserFeedback">农情反馈</el-menu-item>
              <!-- <el-menu-item index="UserFeedback">用户反馈</el-menu-item> -->
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="4">
            <template slot="title">
              <i class="el-icon-s-platform"></i>
              <span>基础设置</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/AreaList">区域管理</el-menu-item>
              <el-menu-item index="/PlanList">作物查看</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="5">
            <template slot="title">
              <i class="el-icon-s-tools"></i>
              <span>系统设置</span>
            </template>
            <el-menu-item-group>
              <!-- <el-menu-item index="1-1">用户管理</el-menu-item> -->
              <el-menu-item index="UserData">微信用户管理</el-menu-item>
              <!-- <el-menu-item index="5-1">角色管理</el-menu-item> -->
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-container class="myasideBox">
        <el-header>
          <div style="width:100%;height:100%;background-color:#3C9DFC" class="headerBox">
            <div class="slidBtnBox" @click="isCollapseChange">
              <i class="el-icon-caret-left" v-show="!isCollapse"></i>
              <i class="el-icon-caret-right" v-show="isCollapse"></i>
            </div>
            <div class="headerUserInfoBox">
              <div class="userName">
                <img
                  src="https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif?imageView2/1/w/80/h/80"
                  alt
                />
              </div>
              <div>
                <el-dropdown>
                  <span class="el-dropdown-link">
                    redu
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>切换账号</el-dropdown-item>
                    <el-dropdown-item>用户信息</el-dropdown-item>
                    <el-dropdown-item>
                      <div @click="loginOut">退出登录</div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
        </el-header>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input1: "",
      isCollapse: false,
      asideWidth: "200px"
    };
  },
  methods: {
    loginOut() {
      this.$router.push("/");
    },
    isCollapseChange() {
      this.isCollapse = !this.isCollapse;
      if (!this.isCollapse) {
        this.asideWidth = "200px";
      } else {
        this.asideWidth = "65px";
      }
    }
  }
};
</script>

<style>
.el-header {
  padding: 0 !important;
}
.myasideBox {
  /* overflow: hidden; */
  /* border-right: 3px solid #304156; */
  /* overflow: hidden; */
}
.headerBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.logoBox {
  height: 60px;
  width: 100%;
  background-color: #3387d9;
  display: flex;
  /* justify-content: ; */
  align-items: center;
}
.slidBtnBox {
  font-size: 25px;
  color: white;
  text-align: center;
  width: 50px;
}
.headerUserInfoBox {
  width: 120px;
  height: 50px;
  /* background-color: aqua; */
  display: flex;
  /* justify-content: end; */
  /* float: right; */
  align-items: center;
}
.userName {
  /* font-size: 20px; */
  /* line-height: 50px; */
  width: 40px;
  height: 40px;
  /* color: #409eff; */
  border-radius: 5px;
  overflow: hidden;
}
.userName img {
  width: 40px;
  height: 40px;
}
.el-dropdown-link {
  color: white;
  font-size: 15px;
  font-weight: 700;
}
.logoImg {
  height: 45px;
  width: 45px;
  border-radius: 50%;
  overflow: hidden;
}
.logoText {
  color: white;
  font-weight: 700;
  font-size: 18px;
  margin-left: 5px;
}
.el-submenu__title {
  text-align: left !important;
}
.el-menu-item {
  text-align: left !important;
}
</style>